import { http } from '../http'
import { postSSE } from '../sse'
import { ERROR_CODES } from '../errors'
import type { CreateThreadDataWithModel, CreateMessageDataWithModel, cancelThreadStreamData } from '@/types'

let abortController: AbortController | null = null

export function beginRequest(): AbortSignal {
	abortController = new AbortController()
	return abortController.signal
}

export function abortActiveRequest(): void {
	if (abortController) {
		abortController.abort()
		abortController = null
	}
}

export async function createThreadStream(data: CreateThreadDataWithModel) {
	const signal = beginRequest()
	return postSSE('threads', {
		body: JSON.stringify(data),
		signal,
		headers: { 'Content-Type': 'application/json' }
	})
}

export async function createMessageStream(data: CreateMessageDataWithModel) {
	const signal = beginRequest()
	const formData = new FormData()
	formData.append('thread_id', JSON.stringify(data.thread_id))
	formData.append('promt', data.promt)
	formData.append('model_name', data.model_name)
	formData.append('is_reasoning', String(!!data.is_reasoning))
	data.document && formData.append('document', data.document)
	return postSSE('messages', {
		body: formData,
		signal,
		// Валидация формата вложения приходит текстом без кода — приводим к коду,
		// чтобы стор не искал подстроку в сообщении бэка.
		onNotOk: (error) => {
			if (/must be a file of type/i.test(error.raw ?? '')) {
				error.code = ERROR_CODES.UNSUPPORTED_DOCUMENT
			}
		}
	})
}

export async function getThread(id: number) {
	return http.get(`/threads/${id}`).then((response) => response.data)
}

export async function getThreadsList() {
	return http.get(`/threads`).then((response) => response.data)
}

export async function deleteThread(id: number) {
	return http.delete(`/threads/${id}`).then((response) => response.status)
}

export function cancelThreadStream(data: cancelThreadStreamData) {
	return http.post(`/stop-stream`, data).then((response) => response.data)
}

export function cancelThreadStreamRequest() {
	abortActiveRequest()
}
